module.exports = __webpack_public_path__ + "static/media/oca.e1098bbb.png";